<mat-form-field subscriptSizing="dynamic" appearance="outline" class="py-2 w-100">
	<mat-label>Wpisz ilość załogi</mat-label>
	<input type="number" matInput [formControl]="crewControl" />
	@if (crewControl.errors?.['crewExceedsCapacity']) {
		<mat-error class="text-small">Zbyt duża załoga</mat-error>
	}
	@if (crewControl.errors?.['min']) {
		<mat-error class="text-small">Ilość załogi nie może być ujemna</mat-error>
	}
</mat-form-field>
